<template>
    <div class="tier-item" :class="theme" @click="clickTier()">
        <div class="wrapper flex" :class="{ inactive: !isActive }">
            <div class="info flex-1 items-center">
                <div class="point">{{ formatPoint(item.Points, 0) }}</div>
                <div class="text-name">{{ blobConfig.appName }}</div>
            </div>
            <div class="wrapper-arrow flex-none">
                <img class="arrow-right" :src="blobConfig.arrowUrl" />
            </div>
            <div class="info flex-1">
                <div class="point">
                    {{ formatPoint(pointConverted) }}
                </div>
                <div class="text-name">{{ lbl.exchangeName}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import Utility from "@/helper/Utility";
import { inject } from "vue";

export default {
    name: "TierItem",
    props: {
        theme: String,
        item: Object,
    },
    emits: ["onClickTier"],
    inject: ["LandingStates", "TransferPointStates", "YesCoinStates"],
    data: function () {
        return {};
    },
    setup: function () {
        const { lbl } = inject("LocaleStore")

        return {
            lbl
        }
    },
    computed: {
        points: function () {
            return this.YesCoinStates.userPoints.value;
        },
        transDetail: function () {
            // console.log(this.TransferPointStates)
            return this.TransferPointStates.resultCheck ?? {};
        },
        currentRate: function () {
            return this.transDetail.rate;
        },
        blobConfig: function () {
            return this.LandingStates.appConfig
        },
        isActive: function () {
            if (this.points >= this.item.Points) {
                return true;
            }
            return false;
        },
        pointConverted: function () {
            // return this.item.Points * this.currentRate
            return Math.floor(this.item.Points * this.currentRate * 10000) / 10000;
        },
    },
    methods: {
        clickTier: function () {
            if (!this.isActive) return

            this.$emit("onClickTier", {
                tier: this.item,
                points: this.pointConverted,
            });
        },
        formatPoint: function (point, d = 4) {
            // console.log(point)
            return Utility.formatNum(point, d);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/module/Bitkub/style/base.scss";
@import "style/TierItem.scss";
</style>

